/* External dependencies */
import { Action } from 'redux';
import get from 'lodash/get';

/* Internal dependencies */
import { generateActionCreator } from '../helpers/duckGenerators';
import { ApplicationState } from '..';
import { User } from '../../types/User';
import Community from '../../types/Community';
import Artist from '../../types/Artist';
import { ProfileType } from 'src/types/Profile';
import { getUser } from './users';
import { getCommunity } from './communities';
import { getArtist } from './artists';
import { getVenue } from './venues';

enum CurrentProfileActionType {
  UPDATE_CURRENT_PROFILE = 'reducer/currentProfile/UPDATE_CURRENT_PROFILE',
  RESET_CURRENT_PROFILE = 'reducer/currentProfile/RESET_CURRENT_PROFILE',
}

export type Profile = User | Community | Artist

export type CurrentProfileState = ProfileType | null;

/* Selectors */
export const getCurrentProfile = (state: ApplicationState) => state.currentProfile;

/* Action creators */
export const updateCurrentProfile = generateActionCreator<CurrentProfileActionType.UPDATE_CURRENT_PROFILE, CurrentProfileState>(
  CurrentProfileActionType.UPDATE_CURRENT_PROFILE
);

export const resetCurrentProfile = generateActionCreator<CurrentProfileActionType.RESET_CURRENT_PROFILE, CurrentProfileState>(
  CurrentProfileActionType.RESET_CURRENT_PROFILE
);

export const getProfile = (state: ApplicationState, profileId: string) => {
  const profileType = profileId.split(':')[0];

  if (profileType === 'user') {
    return getUser(state, profileId);
  } else if (profileType === 'community') {
    return getCommunity(state, profileId);
  } else if (profileType === 'artist') {
    return getArtist(state, profileId);
  } else if (profileType === 'venue') {
    return getVenue(state, profileId);
  }
};

export const INITIAL_STATE = null;

/* Reducer */
const currentProfileReducer = (
  state: CurrentProfileState = INITIAL_STATE,
  action: Action & { payload: Profile }
): CurrentProfileState => {
  const { payload } = action;
  if (action.type === CurrentProfileActionType.UPDATE_CURRENT_PROFILE) {
    return {
      ...payload,
    };
  }

  if (action.type === CurrentProfileActionType.RESET_CURRENT_PROFILE) {
    return {
      location: get(state, 'location'), // TODO: to avoid issue with "undefined" being an invalid coordinate. Should truthy check wherever this error is thrown
    } as CurrentProfileState;
  }

  return state;
};

export default currentProfileReducer;
